import { useState } from 'react';
import {
  Box,
  Button,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import { LANGUAGE_VERSIONS } from '../../constants/constants';

const languages = Object.entries(LANGUAGE_VERSIONS);

const LanguageSelector = ({ language, onSelect }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (lang) => {
    onSelect(lang);
    handleClose();
  };

  return (
    <Box sx={{ ml: 1, mb: 2 }}>
      <Typography variant="h6" component="p" sx={{ mb: 1 }}>
        Language:
      </Typography>
      <Button
        variant="outlined"
        onClick={handleClick}
        sx={{
          color: 'primary.main',
          borderColor: 'primary.main',
          '&:hover': {
            borderColor: 'primary.main',
          },
        }}
      >
        {language}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          sx: { bgcolor: 'background.paper' },
        }}
      >
        {languages.map(([lang, version]) => (
          <MenuItem
            key={lang}
            onClick={() => handleMenuItemClick(lang)}
            sx={{
              color: lang === language ? 'primary.main' : 'inherit',
              bgcolor: lang === language ? 'rgba(255, 255, 255, 0.08)' : 'transparent',
              '&:hover': {
                color: 'primary.main',
                bgcolor: 'rgba(255, 255, 255, 0.08)',
              },
            }}
          >
            {lang}
            <Typography variant="body2" component="span" sx={{ color: 'text.secondary', ml: 1 }}>
              ({version})
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
export default LanguageSelector;